"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hslaToStr = exports.hslToStr = void 0;
var tslib_1 = require("tslib");
var hslToStr = function (_a) {
    var _b = tslib_1.__read(_a, 3), h = _b[0], s = _b[1], l = _b[2];
    return "hsl(".concat(h, ", ").concat(s, "%, ").concat(l, "%)");
};
exports.hslToStr = hslToStr;
var hslaToStr = function (_a) {
    var _b = tslib_1.__read(_a, 4), h = _b[0], s = _b[1], l = _b[2], a = _b[3];
    return "hsla(".concat(h, ", ").concat(s, "%, ").concat(l, "%, ").concat(a, ")");
};
exports.hslaToStr = hslaToStr;
